//PJQProjectWallAdmin-ProjectPhotos
var layoutProjectPhotos;
var gridProjectPhotos;
var bidDocUploadInit = null;

function PJQProjectWallAdminProjectPhotosInitialize() {

	var parentWidth = jQuery('#project-photos-container').width();
	var parentHeight = jQuery('#pjq-main').height();

	if (parentHeight < jQuery(window).height() - 350)
		parentHeight = jQuery(window).height() - 350;

	jQuery('#project-photos-container').css('width', parentWidth + 'px');
	jQuery('#project-photos-container').css('height', parentHeight + 'px');

	var dhxLayoutData = {
		parent: "project-photos-container",
		pattern: "2U",
		cells: [{
			id: "a",
			text: "Project Photos",
			collaspedText: "Project Photos",
			width: 400,
			height: 600
		}, {
			id: "b",
			text: "Photo Details",
			header: false
		}]
	};
	if (null == layoutProjectPhotos) {
		layoutProjectPhotos = new dhtmlXLayoutObject(dhxLayoutData);
		jQuery("div[ida='dhxMainCont']", layoutProjectPhotos.cells("a")).addClass('pjq-drag-drop-background');
		layoutProjectPhotos.cells("b").attachObject('project-photo-image');
	}

	gridProjectPhotos = layoutProjectPhotos.cells("a").attachGrid();
	gridProjectPhotos.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	gridProjectPhotos.setHeader("Title,&nbsp;");
	gridProjectPhotos.setNoHeader(true);
	gridProjectPhotos.setInitWidthsP("90,10");
	gridProjectPhotos.setColAlign("left,center");
	gridProjectPhotos.setColTypes("ed,ro");
	gridProjectPhotos.setColSorting("str,na");
	gridProjectPhotos.enableTooltips("false,false");
	gridProjectPhotos.setSkin(pjqGridTheme);
	gridProjectPhotos.init();
	gridProjectPhotos.enableAutoHeight(true);

	gridProjectPhotos.load('/DesktopModules/PJQProjectWallAdmin/PP.xml?x=' + (new Date).getTime(), 'xml');

	jQuery('#project-photo-image').attr('src', '/i/SampleProjectPhoto.jpg');
}

function DeleteContactsITB() {
	let deleteObj = {};
	_.each(settings.SelectectContactsTemp, function (projectContactId) {
		deleteObj[projectContactId] = [];
	});

	if (gridITBGroupBy === 'view_group') {
		gridITB.forEachRow(function (id) {
			let subGrid = gridITB.cells(id, 0).getSubGrid();
			if (!subGrid)
				return;

			subGrid.forEachRow(function (projectContactId) {
				//Remove contacts from the delete object that are unchecked
				//They will be added below into the temp object with the groups they are checked for in the UI
				let isChecked = subGrid.cells(projectContactId, GetCheckboxColIndex(subGrid)).isChecked();
				if (deleteObj[projectContactId] != null && !isChecked) {
					deleteObj = _.omit(deleteObj, projectContactId);
				}
				else if (isChecked) {
					if (deleteObj[projectContactId] == null) {
						deleteObj[projectContactId] = [];
					}
					deleteObj[projectContactId].push(parseInt(subGrid.getUserData(projectContactId, 'GroupId')));
				}
			});
		});

		//Merge the delete group back in where they contact isn't already globally selected
		// 2018-12-19 BLUE: undoing the use of tempDeleteObj as the below call to merge doesn't work as expected.
		//deleteObj = _.defaults(deleteObj, tempDeleteObj);
	}

	let deleteLoader = new PJQ.Loader($('#project-itb'));
	new PJQ.ajax.Request({
		endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'participants'
			}
		]),
		data: {
			deleteData: deleteObj
		}
	}).delete().done(_.bind(function () {
		subgridCheckedRows = '';
		settings.SelectectContactsTemp = [];
		deleteLoader.remove();
		RefreshGridITBC();
	}, this)).fail(_.bind(function (xhr, err, result) {
		new PJQ.logging.Debug(PJQ.logging.LoggingActions.DELETE_PROJECT_CONTACTS_OR_GROUPS, {
			data: deleteObj,
			error: err,
			result: result
		});
		deleteLoader.remove();
	}, this));
}

function DeleteContactITB() {
	if (gridITBGroupBy == 'view_group') {
		var groupId = subGridLast.getUserData(subGridLast.getSelectedRowId(), 'GroupId');
		PanteraScript.PanteraScriptService.DeleteProjectContactGroup(PJQ.app.session.id, subgridCheckedRows, groupId, RefreshGridITBC, onScriptError);
	}
	else if (gridITBGroupBy != 'view_message')
		PanteraScript.PanteraScriptService.DeleteProjectContacts(PJQ.app.session.id, subgridCheckedRows, RefreshGridITBC, onScriptError);
}

function RefreshGridITBC() {
	InitializeGridITB(gridITBGroupBy);
}

function EditContactCC() {
	PanteraScript.PanteraScriptService.GetContactInfo(pjqSessionId, 'pc', subgridCheckedRows, EditContactCCC, ContactDeleted);
}

function ContactDeleted() {
	// remove from selected list.
	var j,
		index = -1;
	for (j = 0; j < settings.SelectectContactsTemp.length; j++) {
		if (settings.SelectectContactsTemp[j] == parseInt(subgridCheckedRows))
			index = j;
	}

	if (index != -1)
		settings.SelectectContactsTemp.splice(index, 1);

	RefreshGridITBC();
}

function EditContactCCC(response) {

	if (!gridITBGroupBy.startsWith('view_group') && gridITBGroupBy != "view_message")
		InitializeGridITB(gridITBGroupBy);
	else {

		let $newModule = $('.nav-content');
		if($newModule){
			var nx = $newModule[0].scrollLeft;
			var ny = $newModule[0].scrollTop;
		}
		var wx = window.scrollX,
			wy = window.scrollY;


		if (gridITB.cells(gridITB.getSelectedRowId(), 0).isOpen())
			gridITB.cells(gridITB.getSelectedRowId(), 0).close();

		var subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();

		var url = subgrid.xmlFileUrl + '&x' + (new Date).getTime().toString() + '=1';
		subgrid.clearAll();
		subgrid.loadXML(url, function () {
			subgrid.setSizes();
			subgrid.callEvent("onGridReconstructed", []);
			gridITB.setSizes();
		});

		gridITB.cells(gridITB.getSelectedRowId(), 0).open();

		if($newModule){
			$newModule[0].scrollTo(nx, ny)
		}
		else {
			window.scrollTo(wx, wy);
		}
	}
}

dhtmlXGridObject.prototype.disableContextMenu = function () {
	this.entBox.oncontextmenu = function (e) {
		(e || event).cancelBubble = true;
		return false
	}
}

function ShowBusyITB(message) {
	if (jQuery('#tabsMain').tabs('option', 'active') != 2)
		return;

	ShowBusy(message);
}

function ToggleProjectMessageSend() {
	var disabled = jQuery("#project-message-send").button("option", "disabled");
	jQuery("#project-message-send").button("option", "disabled", !disabled);
}

function CopyProjectMsg(projectMessageId) {
	PanteraScript.PanteraScriptService.GetProjectMessageCopyAttachments(PJQ.app.session.id, parseInt(projectMessageId), CopyProjectMsgC, onScriptError);
}

function CopyProjectMsgC(response) {
	pmCopy = jQuery.parseJSON(response);
	ShowProjectMessageDialog(pmCopy.TemplateKey);
}

function InsertToken(sender) {
	jQuery("#message-token-list").addClass("pjq-hidden");

	if (pjqIsIE && pjqBrowserVersion < 9) {
		jQuery('#token-header').text('Message Tokens');
		return;
	}

	if (!pjqIsIE && !document.frames) {
		msgEditor.runCommand("insertHTML", sender.innerHTML);
	}
	else {
		var doc = document.frames[2].document;
		var sel,
			range;
		if (doc.getSelection) {
			// IE9 and non-IE
			sel = doc.getSelection();
			if (sel.getRangeAt && sel.rangeCount) {
				range = sel.getRangeAt(0);
				range.deleteContents();

				// Range.createContextualFragment() would be useful here but is
				// only relatively recently standardized and is not supported in
				// some browsers (IE9, for one)
				var el = doc.createElement("div");
				el.innerHTML = sender.innerHTML;
				var frag = doc.createDocumentFragment(),
					node,
					lastNode;
				while ((node = el.firstChild)) {
					lastNode = frag.appendChild(node);
				}
				range.insertNode(frag);

				// Preserve the selection
				if (lastNode) {
					range = range.cloneRange();
					range.setStartAfter(lastNode);
					range.collapse(true);
					sel.removeAllRanges();
					sel.addRange(range);
				}

			}
		}
		else if (doc.selection && doc.selection.type != "Control") {
			// IE > 9
			doc.selection.createRange().text = sender.innerHTML;
			//doc.selection.createRange().pasteHTML("<span>"+sender.innerHTML+"</span>");
		}
	}
	PMPreview();
}

function PMBidDueChange() {
	if (jQuery('#project-message-response-due').val().trim().length > 0)
		jQuery('#project-message-response-due-asap').attr('checked', false);

	PMPreview();
}

function PMBidDueASAPChange() {

	if (jQuery('#project-message-response-due-asap').prop('checked')) {
		jQuery('#project-message-response-due').val('');
		jQuery('#project-message-response-due').attr("disabled", true);
		jQuery("#project-message-response-due").datepicker("option", "disabled", true);
		PMPreview();
	}
	else {
		jQuery('#project-message-response-due').removeAttr("disabled");
		jQuery("#project-message-response-due").datepicker("option", "disabled", false);
		PMBidDueChange();
	}

}

function PMDetachPF() {
	if (settings.PrivateFolderCount > 0 && settings.IsPMAttachPrivate) {
		jQuery('#project-message-attachments').css('width', '100%');
		jQuery('#pm-upload-files').css('width', '49%');
		jQuery('#project-message-private-folders').addClass('pjq-hidden');
		jQuery('#attach-private-folders').removeClass('pjq-hidden');
		if (tvPMPrivate)
			tvPMPrivate.setSubChecked('0', false);
	}
}

function PMAttachPF() {
	jQuery('#project-message-attachments').css('width', '49%');
	jQuery('#pm-upload-files').css('width', '100%');
	jQuery('#project-message-private-folders').removeClass('pjq-hidden');
	jQuery('#attach-private-folders').addClass('pjq-hidden');
	jQuery('#detach-private-folders').button();

	if (null != tvPMPrivate)
		tvPMPrivate.destructor();
	tvPMPrivate = new dhtmlXTreeObject("project-message-private-tree", "95%", "100%", 0);
	tvPMPrivate.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvPMPrivate.enableMultiLineItems("200px");
	tvPMPrivate.enableTreeLines(false);
	tvPMPrivate.enableContextMenu(cmPrivate);
	tvPMPrivate.enableItemEditor(false);
	tvPMPrivate.setDataMode('json');
	tvPMPrivate.enableCheckBoxes(true);
	tvPMPrivate.enableSmartCheckboxes(true);
	tvPMPrivate.enableThreeStateCheckboxes(true);
	tvPMPrivate.loadXML("/DesktopModules/PJQProjectWallAdmin/GetPrivateFolders.aspx?sessionid=" + pjqSessionId + "&id=0&fc=1&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), tpmpfAfterLoad);
}

function PMPreInit() {
	var newOpts = new Array();
	var i = 0;
	var newOption = '';
	jQuery('#project-message-type option').remove();
	for (i = 0; i < settings.ProjectMessageTemplates.length; i++) {
		newOpts.push(new Array(settings.ProjectMessageTemplates[i].TemplateKey, 'obj', settings.ProjectMessageTemplates[i].TemplateName, ''));
		newOption = "<option value='" + settings.ProjectMessageTemplates[i].TemplateKey + "'>" + settings.ProjectMessageTemplates[i].TemplateName + "</option>";
		jQuery('#project-message-type').append(newOption);
	}

	if (settings.ProjectMessageTemplates.length == 1 || settings.ProjectMessageTemplates[0].TemplateKey === 'ProjectMessage.1931925107') {
		var extraOption = "<option disabled>To add templates call: (877) 219-9777 or email: customerservice@panteratools.com</option>";
		jQuery('#project-message-type').append(extraOption);
		jQuery('#project-message-type').val(jQuery('#project-message-type:first-child'));
	}

	if (!settings.IsPMAttachPrivate || settings.PrivateFolderCount == 0) {
		jQuery('#project-message-attachments').css('width', '100%');
		jQuery('#pm-upload-files').css('width', '100%');
		jQuery('#project-message-private-folders,#attach-private-folders').addClass('pjq-hidden');
	}
	jQuery('#attach-private-folders').button();

	jQuery("#project-message-send").button();
	PMUploadRefresh(settings.FileUploadGuid);
}

function tpmpfAfterLoad() {
	tvPMPrivate.closeAllItems();
	tvPMPrivate.openItem('2');
	if (settings.PMPrivateFolderIds && settings.PMPrivateFolderIds.length > 0) {
		var folders = settings.PMPrivateFolderIds.split(',');
		var i = 0;
		for (i = 0; i < folders.length; i++) {
			if (folders[i].length > 0)
				tvPMPrivate.setSubChecked(folders[i], true);
		}
	}
}

function FilterDialog(response) {
	GetParticipantInfoC(response);
	FilterExclusiveChanged();

	if (settings.IsShowUnionStatus) {
		jQuery('#filter-unionstatus').show();
		jQuery('#filter-prevwage-label').text(settings.PrevailingWageLabel);
	}
	else
		jQuery('#filter-unionstatus').hide();

	if (settings.IsDirectory)
		jQuery('#filter-directory').show();
	else
		jQuery('#filter-directory').hide();


	jQuery("#filter-window").dialog({
		modal: true,
		title: 'Filter Participants',
		width: 500,
		buttons: {
			"Check All": function () {
				jQuery('#filter-print-order-ignore,#filter-downloaded-ignore,#filter-visited-ignore,#filter-directory-ignore').prop('checked', true);
				jQuery('td.filter-response-status-list input, #filter-response-group-list input, #filter-union, #filter-nonunion, #filter-prevwage').each(function () {
					if (!jQuery(this).prop('disabled') && jQuery(this).is(':visible'))
						jQuery(this).prop('checked', true);
				});
				jQuery('#filter-broadcast-status-email-sent,#filter-broadcast-status-email-failed,#filter-broadcast-status-fax-sent,#filter-broadcast-status-fax-failed,#filter-broadcast-status-error').each(function () {
					if (!jQuery(this).prop('disabled') && jQuery(this).is(':visible'))
						jQuery(this).prop('checked', true);
				});

				if (settings.GroupLevel > 1 && filterGroupTree)
					filterGroupTree.setSubChecked('0', true);

			},
			"Clear All": function () {
				FilterClearAll();
			},
			"OK": function () {
				if (!jQuery('td.filter-response-status-list input[value="UNSENT"]').prop('checked'))
					filterUnsent = false;
				InitializeGridITB(gridITBGroupBy);
				$(this).dialog("close");
			}
		}
	});
}

function FilterClearAll() {
	jQuery('td.filter-response-status-list input:checked, #filter-response-group-list input:checked, #filter-print-order-yes:checked, #filter-visited-yes:checked,#filter-downloaded-yes:checked,#filter-broadcast-status-email-sent,#filter-broadcast-status-email-failed,#filter-broadcast-status-fax-sent,#filter-broadcast-status-fax-failed,#filter-broadcast-status-error,#filter-union,#filter-nonunion,#filter-prevwage').each(function () {
		jQuery(this).prop('checked', false);
	});
	jQuery('#filter-print-order-ignore,#filter-downloaded-ignore,#filter-visited-ignore,#filter-directory-ignore').prop('checked', true);

	if (settings.GroupLevel > 1 && filterGroupTree)
		filterGroupTree.setSubChecked('0', false);

	filterUnsent = false;
}

function FilterExclusiveChanged() {
	if (jQuery('#filter-print-order-yes').prop('checked') || jQuery('#filter-downloaded-yes').prop('checked') || jQuery('#filter-visited-yes').prop('checked')) {
		jQuery('td.filter-response-status-list input,  #filter-broadcast-status-email-sent,#filter-broadcast-status-email-failed,#filter-broadcast-status-fax-sent,#filter-broadcast-status-fax-failed,#filter-broadcast-status-error,#filter-union,#filter-nonunion,#filter-prevwage').each(function () {
			/* 2018-10-24 BLUE: Experimenting with not doing this to see if it is still necessary.
			jQuery(this).prop('checked', false);
			jQuery(this).prop('disabled', true);
			*/
		});
		/* 2018-10-24 BLUE: Experimenting with not doing this to see if it is still necessary.
	jQuery('#filter-directory-ignore').prop('checked', true);
	jQuery('#filter-directory-ignore,#filter-directory-private,#filter-directory-public').prop('disabled', true);
		*/
	}
	else {
		jQuery('td.filter-response-status-list input,  #filter-broadcast-status-email-sent,#filter-broadcast-status-email-failed,#filter-broadcast-status-fax-sent,#filter-broadcast-status-fax-failed,#filter-broadcast-status-error,#filter-union,#filter-nonunion,#filter-prevwage').each(function () {
			jQuery(this).prop('disabled', false);
		});
		jQuery('#filter-directory-ignore,#filter-directory-private,#filter-directory-public').prop('disabled', false);
	}
}

function GetParticipantInfoC(response) {
	var participantInfo = jQuery.parseJSON(response);
	var newOption = '';

	ssl = '';
	jQuery('td.filter-response-status-list input:checked').each(function () {
		ssl = ssl + decodeURIComponent(jQuery(this).val()) + ',';
	});
	if (ssl.length > 0)
		ssl = ssl.substring(0, ssl.length - 1);
	var statusList = ssl.split(",");

	searchGroupList = '';
	jQuery('#filter-response-group-list input:checked').each(function () {
		searchGroupList = searchGroupList + jQuery(this).val() + ',';
	});
	if (searchGroupList.length > 0)
		searchGroupList = searchGroupList.substring(0, searchGroupList.length - 1);

	if (null != filterGroupTree)
		searchGroupList = filterGroupTree.getAllChecked();

	var groupList = searchGroupList.split(",");

	jQuery('td.filter-response-status-list').html('');

	for (var j = 0; j < participantInfo.StatusList.length; j++) {
		if (participantInfo.StatusList[j].Count == 0)
			continue;

		if (participantInfo.StatusList[j].Value == 'UNSENT') {
			var checked = '';
			if (statusList.indexOf(participantInfo.StatusList[j].Value) > -1 || (participantInfo.StatusList[j].Value == 'UNSENT' && filterUnsent))
				checked = " checked='checked'";
			newOption = "<input type='checkbox' " + checked + " value='" + encodeURIComponent(participantInfo.StatusList[j].Value) + "' />" + participantInfo.StatusList[j].Text + " (" +
				participantInfo.StatusList[j].Count.toString() + ")<br />";
			jQuery('td.filter-response-status-list').append(newOption);
		}
		else if (participantInfo.StatusList[j].Value == 'SENT') {
			var checked = '';
			if (statusList.indexOf(participantInfo.StatusList[j].Value) > -1 || (participantInfo.StatusList[j].Value == 'SENT' && filterUnsent))
				checked = " checked='checked'";
			newOption = "<input type='checkbox' " + checked + " value='" + encodeURIComponent(participantInfo.StatusList[j].Value) + "' />" + participantInfo.StatusList[j].Text + " (" +
				participantInfo.StatusList[j].Count.toString() + ")<br />";
			jQuery('td.filter-response-status-list').append(newOption);
		}
		else if (participantInfo.StatusList[j].Value == 'PENDING') {
			var checked = '';
			if (statusList.indexOf(participantInfo.StatusList[j].Value) > -1)
				checked = " checked='checked'";
			newOption = "<input type='checkbox' " + checked + " value='" + encodeURIComponent(participantInfo.StatusList[j].Value) + "' />" + participantInfo.StatusList[j].Text + " (" +
				participantInfo.StatusList[j].Count.toString() + ")<br />";
			jQuery('td.filter-response-status-list').append(newOption);
		}
		else {
			for (var i = 0; i < settings.ProjectStatus.length; i++) {
				if (settings.ProjectStatus[i] == participantInfo.StatusList[j].Value) {
					var checked = '';
					if (statusList.indexOf(participantInfo.StatusList[j].Value) > -1)
						checked = " checked='checked'";
					newOption = "<input type='checkbox' " + checked + " value='" + encodeURIComponent(participantInfo.StatusList[j].Value) + "' />" + participantInfo.StatusList[j].Text + " (" +
						participantInfo.StatusList[j].Count.toString() + ")<br />";
					jQuery('td.filter-response-status-list').append(newOption);
				}
			}
		}
	}

	if (null != filterGroupTree) {
		filterGroupTree.destructor();
		filterGroupTree = null;
	}
	jQuery('#filter-response-group-list').html("");
	if (settings.GroupLevel <= 1) {
		for (i = 0; i < participantInfo.GroupList.length; i++) {
			var displayValue = participantInfo.GroupList[i].Text;
			if (participantInfo.GroupList[i].Text.startsWith('NO GROUP'))
				displayValue = "<b>" + displayValue + "</b>";
			var checked = '';
			if (groupList.indexOf(participantInfo.GroupList[i].Value) > -1)
				checked = " checked='checked'";
			newOption = "<input type='checkbox' " + checked + " value='" + encodeURIComponent(participantInfo.GroupList[i].Value) + "' />" + displayValue + " (" + participantInfo.GroupList[i].Count.toString() + ")<br />";
			jQuery('#filter-response-group-list').append(newOption);
		}
	}
	else {
		if (null == filterGroupTree) {
			filterGroupTree = new dhtmlXTreeObject("filter-response-group-list", "100%", "100%", 0);
			filterGroupTree.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
			filterGroupTree.enableCheckBoxes(1);
			filterGroupTree.enableMultiLineItems("300px");
			filterGroupTree.enableTreeLines(false);
			filterGroupTree.enableTreeImages(false);
			filterGroupTree.setOnClickHandler(filterGroupTreeClick);
			filterGroupTree.setDataMode('json');
			jQuery('#filter-response-group-list').prepend("<div id='filter-response-groups-busy'><img src='/i/ajax-loader.gif' alt='Busy...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>Loading...</span></div>");

			filterGroupTree.loadJSON('/DesktopModules/PJQProjectWallAdmin/GetGroupTree.aspx?sessionid=' + PJQ.app.session.id, filterGroupTreeC);
		}
		jQuery('#filter-response-group-list').css('height', '250px');
	}
}

function filterGroupTreeC() {
	jQuery('#filter-response-groups-busy').remove();
	var groupList = searchGroupList.split(",");
	var i = 0;
	for (i = 0; i < groupList.length; i++) {
		filterGroupTree.setCheck(groupList[i], 1);
		filterGroupTree.openItem(groupList[i]);
	}
}

function filterGroupTreeClick() {
	if (parseInt(id) <= 0) {
		if (filterGroupTree.hasChildren(id)) {
			if (filterGroupTree.getOpenState(id) == 1)
				filterGroupTree.closeItem(id);
			else
				filterGroupTree.openItem(id);
		}
		return;
	}
	if (filterGroupTree.isItemChecked(id))
		filterGroupTree.setCheck(id, 0);
	else
		filterGroupTree.setCheck(id, 1);
}

//custom columns

function eXcell_sub_row2(b) {
	if (b)
		this.cell = b, this.grid = this.cell.parentNode.grid;
	this.getValue = function () {
		return this.grid.getUserData(this.cell.parentNode.idd, "__sub_row2")
	};
	this._setState = function (a, b) {
		(b || this.cell).innerHTML = "<img src='" + this.grid.imgURL + a + "' width='18' height='18' />";
		(b || this.cell).firstChild.onclick = this.grid._expandMonolite2
	};
	this.open = function () {
		this.cell.firstChild.onclick(null, !0)
	};
	this.close = function () {
		this.cell.firstChild.onclick(null, !1, !0)
	};
	this.isOpen = function () {
		return !!this.cell.parentNode._expanded
	};
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row2", a);
		this._setState(a ? "plus.gif" : "blanc.gif")
	};
	this.setContent = function (a) {
		this.cell.parentNode._expanded ? (this.cell.parentNode._expanded.innerHTML = a, this.resize()) : (this.cell._previous_content = null, this.setValue(a), this.cell._sub_row_type = null)
	};
	this.resize = function () {
		this.grid._detectHeight(this.cell.parentNode._expanded, this.cell, this.cell.parentNode._expanded.scrollHeight)
	};
	this.isDisabled = function () {
		return !0
	};
	this.getTitle = function () {
		return this.grid.getUserData(this.cell.parentNode.idd, "__sub_row2") ? "click to expand|collapse" : ""
	}
}

eXcell_sub_row2.prototype = new eXcell;

function eXcell_sub_row2_ajax(b) {
	this.base = eXcell_sub_row2;
	this.base(b);
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row2", a);
		this.cell._sub_row_type = "ajax";
		this.cell._previous_content = null;
		this._setState(a ? "plus.gif" : "blanc.gif")
	}
}

eXcell_sub_row2_ajax.prototype = new eXcell_sub_row2;

function eXcell_sub_row2_grid(b) {
	this.base = eXcell_sub_row2;
	this.base(b);
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row2", a);
		this.cell._sub_row_type = "grid";
		this._setState(a ? "plus.gif" : "blanc.gif")
	};
	this.getSubGrid = function () {
		return !b._sub_grid ? null : b._sub_grid
	}
}

eXcell_sub_row2_grid.prototype = new eXcell_sub_row2;

dhtmlXGridObject.prototype._sub_row2_render = {
	ajax: function (b, a, d, f) {
		a.innerHTML = "Loading...";
		var e = new dtmlXMLLoaderObject(function () {
			a.innerHTML = e.xmlDoc.responseText;
			var c = e.xmlDoc.responseText.match(/<script[^>]*>([^<]+)<\/script>/g);
			if (c)
				for (var f = 0; f < c.length; f++)
					eval(c[f].replace(/<([\/]{0,1})s[^>]*>/g, ""));
			b._detectHeight(a, d);
			b._correctMonolite();
			b.setUserData(d.parentNode.idd, "__sub_row2", e.xmlDoc.responseText);
			d._sub_row_type = null;
			b._ahgr && b.setSizes();
			b.callEvent("onSubAjaxLoad", [d.parentNode.idd,
				e.xmlDoc.responseText
			])
		}, this, !0, !0);
		e.loadXML(f)
	},
	grid: function (b, a, d, f) {
		d._sub_grid = new dhtmlXGridObject(a);
		b.skin_name && d._sub_grid.setSkin(b.skin_name);
		d._sub_grid.parentGrid = b;
		d._sub_grid.setImagePath(b.imgURL);
		d._sub_grid.enableAutoHeight(!0);
		d._sub_grid._delta_x = d._sub_grid._delta_y = null;
		d._sub_grid.attachEvent("onGridReconstructed", function () {
			b._detectHeight(a, d, d._sub_grid.objBox.scrollHeight + d._sub_grid.hdr.offsetHeight + (this.ftr ? this.ftr.offsetHeight : 0));
			b._correctMonolite();
			this.setSizes();
			b.parentGrid && b.callEvent("onGridReconstructed", [])
		});
		b.callEvent("onSubGridCreated", [d._sub_grid, d.parentNode.idd, d._cellIndex, f]) && d._sub_grid.loadXML(f, function () {
			b._detectHeight(a, d, d._sub_grid.objBox.scrollHeight + d._sub_grid.hdr.offsetHeight + (d._sub_grid.ftr ? d._sub_grid.ftr.offsetHeight : 0));
			d._sub_grid.objBox.style.overflow = "hidden";
			b._correctMonolite();
			d._sub_row_type = null;
			b.callEvent("onSubGridLoaded", [d._sub_grid, d.parentNode.idd, d._cellIndex, f]) && b._ahgr && b.setSizes()
		})
	}
};

dhtmlXGridObject.prototype._expandMonolite2 = function (b, a, d) {
	var f = this.parentNode,
		e = f.parentNode,
		c = e.grid;
	if (b || window.event)
		!d && !e._expanded && c.editStop(), (b || event).cancelBubble = !0;
	var i = c.getUserData(e.idd, "__sub_row2");

	if (e._expanded) {
		if (c.getUserData(e.idd, "__sub_row_last") != f.cellIndex.toString()) {
			c.cells(e.idd, parseInt(c.getUserData(e.idd, "__sub_row_last"))).close();
		}
		e.style.height = (e.oldHeight || 20) + "px";
		f.style.height = (e.oldHeight || 20) + "px";
	}

	c.setUserData(e.idd, "__sub_row_last", f.cellIndex.toString());

	if (!c._sub_row_editor)
		c._sub_row_editor = new eXcell_sub_row2(f);
	if (i) {
		if (e._expanded && !a) {
			c._sub_row_editor._setState("plus.gif", f);
			f._previous_content = e._expanded;
			c.objBox.removeChild(e._expanded);
			e._expanded = !1;
			e.style.height = (e.oldHeight || 20) + "px";
			f.style.height = (e.oldHeight || 20) +
				"px";
			if (c._fake)
				c._fake.rowsAr[e.idd].style.height = (e.oldHeight || 20) + "px";
			for (var g = 0; g < e.cells.length; g++)
				e.cells[g].style.verticalAlign = "middle", e.cells[g].style.paddingTop = "0px";
			delete c._flow[e.idd];
			c._correctMonolite();
			e._expanded.ctrl = null
		}
		else if (!e._expanded && !d) {
			c._sub_row_editor._setState("minus.gif", f);
			e.oldHeight = jQuery(f).height();
			if (f._previous_content) {
				var h = f._previous_content;
				h.ctrl = f;
				c.objBox.appendChild(h);
				c._detectHeight(h, f, parseInt(h.style.height))
			}
			else {
				h = document.createElement("DIV");
				h.ctrl = f;
				if (f._sub_row_type)
					c._sub_row2_render[f._sub_row_type](c, h, f, i);
				else
					h.innerHTML = i;
				h.style.cssText = "position:absolute; left:0px; top:0px; overflow:auto; font-family:Tahoma; font-size:8pt; margin-top:2px; margin-left:4px;";
				h.className = "dhx_sub_row";
				c.objBox.appendChild(h);
				c._detectHeight(h, f)
			}
			if (!c._flow)
				c.attachEvent("onGridReconstructed", function () {
					this.pagingOn || this._srnd ? this._collapsMonolite() : this._correctMonolite()
				}), c.attachEvent("onResizeEnd", function () {
					this._correctMonolite(!0)
				}),
					c.attachEvent("onAfterCMove", function () {
						this._correctMonolite(!0)
					}), c.attachEvent("onDrop", function () {
					this._correctMonolite(!0)
				}), c.attachEvent("onBeforePageChanged", function () {
					this._collapsMonolite();
					return !0
				}), c.attachEvent("onGroupStateChanged", function () {
					this._correctMonolite();
					return !0
				}), c.attachEvent("onFilterEnd", function () {
					this._collapsMonolite()
				}), c.attachEvent("onUnGroup", function () {
					this._collapsMonolite()
				}), c.attachEvent("onPageChanged", function () {
					this._collapsMonolite()
				}), c.attachEvent("onXLE",
					function () {
						this._collapsMonolite()
					}), c.attachEvent("onClearAll", function () {
					for (var a in this._flow)
						this._flow[a] && this._flow[a].parentNode && this._flow[a].parentNode.removeChild(this._flow[a]);
					this._flow = []
				}), c.attachEvent("onEditCell", function (a, b, c) {
					a !== 2 && this._flow[b] && this.cellType[c] != "ch" && this.cellType[c] != "ra" && this._expandMonolite2.apply(this._flow[b].ctrl.firstChild, [0, !1, !0]);
					return !0
				}), c.attachEvent("onCellChanged", function (a, b) {
					if (this._flow[a]) {
						var c = this.cells(a, b).cell;
						c.style.verticalAlign =
							"top";
						c.style.paddingTop = "3px"
					}
				}), c._flow = [];
			c._flow[e.idd] = h;
			c._correctMonolite();
			for (g = 0; g < e.cells.length; g++)
				e.cells[g].style.verticalAlign = "top", e.cells[g].style.paddingTop = "3px";
			if (c._fake)
				for (var j = c._fake.rowsAr[e.idd], g = 0; g < j.cells.length; g++)
					j.cells[g].style.verticalAlign = "top", j.cells[g].style.paddingTop = "3px";
			f.style.paddingTop = "1px";
			e._expanded = h
		}
		c._ahgr && c.setSizes();
		c.parentGrid && c.callEvent("onGridReconstructed", []);
		c.callEvent("onSubRowOpen", [e.idd, !!e._expanded])
	}
};

// *************************************************************** //
function eXcell_sub_row3(b) {
	if (b)
		this.cell = b, this.grid = this.cell.parentNode.grid;
	this.getValue = function () {
		return this.grid.getUserData(this.cell.parentNode.idd, "__sub_row3")
	};
	this._setState = function (a, b) {
		(b || this.cell).innerHTML = "<img src='" + this.grid.imgURL + a + "' width='18' height='18' />";
		(b || this.cell).firstChild.onclick = this.grid._expandMonolite3
	};
	this.open = function () {
		this.cell.firstChild.onclick(null, !0)
	};
	this.close = function () {
		this.cell.firstChild.onclick(null, !1, !0)
	};
	this.isOpen = function () {
		return !!this.cell.parentNode._expanded
	};
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row3", a);
		this._setState(a ? "plus.gif" : "blanc.gif")
	};
	this.setContent = function (a) {
		this.cell.parentNode._expanded ? (this.cell.parentNode._expanded.innerHTML = a, this.resize()) : (this.cell._previous_content = null, this.setValue(a), this.cell._sub_row_type = null)
	};
	this.resize = function () {
		this.grid._detectHeight(this.cell.parentNode._expanded, this.cell, this.cell.parentNode._expanded.scrollHeight)
	};
	this.isDisabled = function () {
		return !0
	};
	this.getTitle = function () {
		return this.grid.getUserData(this.cell.parentNode.idd, "__sub_row3") ? "click to expand|collapse" : ""
	}
}

eXcell_sub_row3.prototype = new eXcell;

function eXcell_sub_row3_ajax(b) {
	this.base = eXcell_sub_row3;
	this.base(b);
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row3", a);
		this.cell._sub_row_type = "ajax";
		this.cell._previous_content = null;
		this._setState(a ? "plus.gif" : "blanc.gif")
	}
}

eXcell_sub_row3_ajax.prototype = new eXcell_sub_row3;

function eXcell_sub_row3_grid(b) {
	this.base = eXcell_sub_row3;
	this.base(b);
	this.setValue = function (a) {
		a && this.grid.setUserData(this.cell.parentNode.idd, "__sub_row3", a);
		this.cell._sub_row_type = "grid";
		this._setState(a ? "plus.gif" : "blanc.gif")
	};
	this.getSubGrid = function () {
		return !b._sub_grid ? null : b._sub_grid
	}
}

eXcell_sub_row3_grid.prototype = new eXcell_sub_row3;

dhtmlXGridObject.prototype._sub_row3_render = {
	ajax: function (b, a, d, f) {
		a.innerHTML = "Loading...";
		var e = new dtmlXMLLoaderObject(function () {
			a.innerHTML = e.xmlDoc.responseText;
			var c = e.xmlDoc.responseText.match(/<script[^>]*>([^<]+)<\/script>/g);
			if (c)
				for (var f = 0; f < c.length; f++)
					eval(c[f].replace(/<([\/]{0,1})s[^>]*>/g, ""));
			b._detectHeight(a, d);
			b._correctMonolite();
			b.setUserData(d.parentNode.idd, "__sub_row3", e.xmlDoc.responseText);
			d._sub_row_type = null;
			b._ahgr && b.setSizes();
			b.callEvent("onSubAjaxLoad", [d.parentNode.idd,
				e.xmlDoc.responseText
			])
		}, this, !0, !0);
		e.loadXML(f)
	},
	grid: function (b, a, d, f) {
		d._sub_grid = new dhtmlXGridObject(a);
		b.skin_name && d._sub_grid.setSkin(b.skin_name);
		d._sub_grid.parentGrid = b;
		d._sub_grid.setImagePath(b.imgURL);
		d._sub_grid.enableAutoHeight(!0);
		d._sub_grid._delta_x = d._sub_grid._delta_y = null;
		d._sub_grid.attachEvent("onGridReconstructed", function () {
			b._detectHeight(a, d, d._sub_grid.objBox.scrollHeight + d._sub_grid.hdr.offsetHeight + (this.ftr ? this.ftr.offsetHeight : 0));
			b._correctMonolite();
			this.setSizes();
			b.parentGrid && b.callEvent("onGridReconstructed", [])
		});
		b.callEvent("onSubGridCreated", [d._sub_grid, d.parentNode.idd, d._cellIndex, f]) && d._sub_grid.loadXML(f, function () {
			b._detectHeight(a, d, d._sub_grid.objBox.scrollHeight + d._sub_grid.hdr.offsetHeight + (d._sub_grid.ftr ? d._sub_grid.ftr.offsetHeight : 0));
			d._sub_grid.objBox.style.overflow = "hidden";
			b._correctMonolite();
			d._sub_row_type = null;
			b.callEvent("onSubGridLoaded", [d._sub_grid, d.parentNode.idd, d._cellIndex, f]) && b._ahgr && b.setSizes()
		})
	}
};

dhtmlXGridObject.prototype._expandMonolite3 = function (b, a, d) {
	var f = this.parentNode,
		e = f.parentNode,
		c = e.grid;
	if (b || window.event)
		!d && !e._expanded && c.editStop(), (b || event).cancelBubble = !0;
	var i = c.getUserData(e.idd, "__sub_row3");

	if (e._expanded) {
		if (c.getUserData(e.idd, "__sub_row_last") != f.cellIndex.toString()) {
			c.cells(e.idd, parseInt(c.getUserData(e.idd, "__sub_row_last"))).close();
		}
		e.style.height = (e.oldHeight || 20) + "px";
		f.style.height = (e.oldHeight || 20) + "px";
	}

	c.setUserData(e.idd, "__sub_row_last", f.cellIndex.toString());

	if (!c._sub_row_editor)
		c._sub_row_editor = new eXcell_sub_row3(f);
	if (i) {
		if (e._expanded && !a) {
			c._sub_row_editor._setState("plus.gif", f);
			f._previous_content = e._expanded;
			c.objBox.removeChild(e._expanded);
			e._expanded = !1;
			e.style.height = (e.oldHeight || 20) + "px";
			f.style.height = (e.oldHeight || 20) +
				"px";
			if (c._fake)
				c._fake.rowsAr[e.idd].style.height = (e.oldHeight || 20) + "px";
			for (var g = 0; g < e.cells.length; g++)
				e.cells[g].style.verticalAlign = "middle", e.cells[g].style.paddingTop = "0px";
			delete c._flow[e.idd];
			c._correctMonolite();
			e._expanded.ctrl = null
		}
		else if (!e._expanded && !d) {
			c._sub_row_editor._setState("minus.gif", f);
			e.oldHeight = jQuery(f).height();
			if (f._previous_content) {
				var h = f._previous_content;
				h.ctrl = f;
				c.objBox.appendChild(h);
				c._detectHeight(h, f, parseInt(h.style.height))
			}
			else {
				h = document.createElement("DIV");
				h.ctrl = f;
				if (f._sub_row_type)
					c._sub_row3_render[f._sub_row_type](c, h, f, i);
				else
					h.innerHTML = i;
				h.style.cssText = "position:absolute; left:0px; top:0px; overflow:auto; font-family:Tahoma; font-size:8pt; margin-top:2px; margin-left:4px;";
				h.className = "dhx_sub_row";
				c.objBox.appendChild(h);
				c._detectHeight(h, f)
			}
			if (!c._flow)
				c.attachEvent("onGridReconstructed", function () {
					this.pagingOn || this._srnd ? this._collapsMonolite() : this._correctMonolite()
				}), c.attachEvent("onResizeEnd", function () {
					this._correctMonolite(!0)
				}),
					c.attachEvent("onAfterCMove", function () {
						this._correctMonolite(!0)
					}), c.attachEvent("onDrop", function () {
					this._correctMonolite(!0)
				}), c.attachEvent("onBeforePageChanged", function () {
					this._collapsMonolite();
					return !0
				}), c.attachEvent("onGroupStateChanged", function () {
					this._correctMonolite();
					return !0
				}), c.attachEvent("onFilterEnd", function () {
					this._collapsMonolite()
				}), c.attachEvent("onUnGroup", function () {
					this._collapsMonolite()
				}), c.attachEvent("onPageChanged", function () {
					this._collapsMonolite()
				}), c.attachEvent("onXLE",
					function () {
						this._collapsMonolite()
					}), c.attachEvent("onClearAll", function () {
					for (var a in this._flow)
						this._flow[a] && this._flow[a].parentNode && this._flow[a].parentNode.removeChild(this._flow[a]);
					this._flow = []
				}), c.attachEvent("onEditCell", function (a, b, c) {
					a !== 2 && this._flow[b] && this.cellType[c] != "ch" && this.cellType[c] != "ra" && this._expandMonolite3.apply(this._flow[b].ctrl.firstChild, [0, !1, !0]);
					return !0
				}), c.attachEvent("onCellChanged", function (a, b) {
					if (this._flow[a]) {
						var c = this.cells(a, b).cell;
						c.style.verticalAlign =
							"top";
						c.style.paddingTop = "3px"
					}
				}), c._flow = [];
			c._flow[e.idd] = h;
			c._correctMonolite();
			for (g = 0; g < e.cells.length; g++)
				e.cells[g].style.verticalAlign = "top", e.cells[g].style.paddingTop = "3px";
			if (c._fake)
				for (var j = c._fake.rowsAr[e.idd], g = 0; g < j.cells.length; g++)
					j.cells[g].style.verticalAlign = "top", j.cells[g].style.paddingTop = "3px";
			f.style.paddingTop = "1px";
			e._expanded = h
		}
		c._ahgr && c.setSizes();
		c.parentGrid && c.callEvent("onGridReconstructed", []);
		c.callEvent("onSubRowOpen", [e.idd, !!e._expanded])
	}
};

function ProjectGroupStatusChange(sender, groupid, pc) {
	var grid = sender.parentNode.parentNode.grid;
	PanteraScript.PanteraScriptService.SetProjectContactGroupStatus(PJQ.app.session.id, parseInt(pc), parseInt(groupid), decodeURIComponent(jQuery(sender).val()), function (response) {
		if (gridITBGroupBy == 'view_default') {
			gridITB.cells(pc, GetProjectStatusColIndex()).setValue(response);
		}
		else if (gridITBGroupBy == 'view_scope') {
			grid.parentGrid.cells(pc, GetProjectStatusColIndex()).setValue(response);
		}
		else if (gridITBGroupBy == 'view_group') {
			var setStatus = decodeURIComponent(jQuery(sender).val());
			if (GetProjectStatusColIndex() > -1) {
				var parts = pjqITBLayoutGroupCompany.split(',');

				if (grid.getUserData(null, 'IsGroupsGrid') == '1' && parseInt(grid.parentGrid.getUserData(pc, 'GroupId')) == groupid && parts[GetProjectStatusColIndex()].split('|')[2] == 'project_status_group') {
					grid.parentGrid.cells(pc, GetProjectStatusColIndex()).setValue(setStatus);
				}
				else if (grid.getUserData(null, 'IsGroupsGrid') == '1' && parts[GetProjectStatusColIndex()].split('|')[2] == 'project_status_master') {
					grid.parentGrid.cells(pc, GetProjectStatusColIndex()).setValue(response);
				}
				else if (GetGroupsSubGridColIndex() > -1) {
					var subgrid = grid;
					if (grid.getUserData(null, 'IsGroupsGrid') != '1')
						subgrid = grid.cells(pc, GetGroupsSubGridColIndex()).getSubGrid();

					if (subgrid) {

						subgrid.forEachRow(function (groupRowId) {
							if (parseInt(groupid) == parseInt(groupRowId))
								subgrid.cells(groupRowId, 1).setValue(setStatus);
						});
					}
				}
			}

			let isDeclined = (setStatus === settings.ProjectStatus[1]);
			if (isDeclined && !enableDeclined) {
				settings.SelectectContactsTemp = _.filter(settings.SelectectContactsTemp, function (contact) {
					if (contact !== parseInt(pc))
						return true;
				});
			}

			if (grid.getUserData(null, 'IsGroupsGrid') == '1') {
				if (isDeclined) {
					grid.parentGrid.cells(pc, GetCheckboxColIndex(grid.parentGrid)).setChecked(0);
					grid.parentGrid.cells(pc, GetCheckboxColIndex(grid.parentGrid)).setDisabled(!enableDeclined);
				}
				else
					grid.parentGrid.cells(pc, GetCheckboxColIndex(grid.parentGrid)).setDisabled(false);

			}
			else {
				if (isDeclined) {
					grid.cells(pc, GetCheckboxColIndex(grid)).setChecked(0);
					grid.cells(pc, GetCheckboxColIndex(grid)).setDisabled(!enableDeclined);
				}
				else
					grid.cells(pc, GetCheckboxColIndex(grid)).setDisabled(false);

			}
		}

	}, onScriptError);
}

function eXcell_project_status_group(cell) { // project status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {
		var template = "";
		if (this.grid.getUserData(null, 'IsGroupsGrid') == '1') {
			template = "<select class='project-status' pjq-row-id='" + this.cell.parentNode.idd + "' onchange='ProjectGroupStatusChange(this," + this.cell.parentNode.idd + ", " + this.cell.parentNode.grid.getUserData(this.cell.parentNode.idd, 'ProjectContactId') + ")'>";
		}
		else {
			template = "<select class='project-status' pjq-row-id='" + this.cell.parentNode.grid.getUserData(this.cell.parentNode.idd, 'GroupId') + "' onchange='ProjectGroupStatusChange(this," + this.cell.parentNode.grid.getUserData(this.cell.parentNode.idd, 'GroupId') + ", " + this.cell.parentNode.idd + ")'>";
		}

		var i = 0;
		var isSelected = '';
		if (val == '' || val == 'PENDING')
			isSelected = "selected='selected'";
		template += "<option value='PENDING' " + isSelected + ">PENDING</option>";
		for (i = 0; i < settings.ProjectStatus.length; i++) {
			isSelected = '';
			if (val == settings.ProjectStatus[i])
				isSelected = "selected='selected'";
			if (settings.ProjectStatus[i] !== 'PENDING' && settings.ProjectStatus[i] !== 'UNSENT') {
				template += "<option value='" + encodeURIComponent(settings.ProjectStatus[i]) + "' " + isSelected + ">" + settings.ProjectStatus[i] + "</option>";
			}
		}

		template += "</select>";

		this.setCValue(template);
		this.setAttribute('title', val);
	}
}

eXcell_project_status_group.prototype = new eXcell; // nest all other methods from base class

function eXcell_bidamount_group(cell) {
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {
		var row = this.cell.parentNode;
		var grid = row.grid;

		var template = "<div style='width:90%;'>";

		var id = this.cell.parentNode.idd;
		var pc = grid.getUserData(id, 'ProjectContactId');
		if (!pc)
			pc = id;

		var groupId = grid.getUserData(id, 'GroupId');
		if (!groupId)
			groupId = id;

		if (this.grid.getUserData(null, 'IsGroupsGrid') == '1')
			template += "<input type='text' class='contact-bid-amount' value='" + val + "' onblur='ContactGroupBidAmountSave(this, " + groupId + ", " + pc + ");' onkeypress='ContactGroupBidAmountChanged(this, " + this.cell.parentNode.idd + ", " + grid.getUserData(this.cell.parentNode.idd, 'ProjectContactId') + ");' onchange='jQuery(this).val( parseFloat(jQuery(this).val().length == 0 ? 0 : jQuery(this).val()).toFixed(2).toString());' />&nbsp;<img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ContactGroupBidAmountSave(this, " + this.cell.parentNode.idd + ", " + grid.getUserData(this.cell.parentNode.idd, 'ProjectContactId') + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ContactGroupBidAmountCancel(this);' /><input type='hidden' class='contact-misc-bidamount-original' /></div>";
		else
			template += "<input type='text' class='contact-bid-amount' value='" + val + "' onblur='ContactGroupBidAmountSave(this, " + groupId + ", " + pc + ");' onkeypress='ContactGroupBidAmountChanged(this, " + grid.getUserData(this.cell.parentNode.idd, 'GroupId') + ", " + this.cell.parentNode.idd + ");' onchange='jQuery(this).val( parseFloat(jQuery(this).val().length == 0 ? 0 : jQuery(this).val()).toFixed(2).toString());' />&nbsp;<img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ContactGroupBidAmountSave(this, " + grid.getUserData(this.cell.parentNode.idd, 'GroupId') + ", " + this.cell.parentNode.idd + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ContactGroupBidAmountCancel(this);' /><input type='hidden' class='contact-misc-bidamount-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_bidamount_group.prototype = new eXcell; // nest all other methods from base class
eXcell_bidamount_group.prototype.getTitle = function () {

	var tip = jQuery("input.contact-bid-amount", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return '';
}

function ContactGroupBidAmountChanged(sender, id, pc) {
	if (typeof (event) != 'undefined' && (event.keyCode == 13 || event.keyCode == 9)) {
		event.preventDefault();
		//var subgrid = gridITB.cells(pc, GetGroupsSubGridColIndex()).getSubGrid();
		jQuery("input.contact-bid-amount", jQuery(sender).parent()).blur();
		jQuery("img.contact-misc-save", jQuery(sender).parent()).click();
		var subgrid = null;
		if (gridITBGroupBy == 'view_default' || gridITBGroupBy == 'view_scope') {
			if (gridITBGroupBy == 'view_default')
				subgrid = gridITB.cells(pc, GetGroupsSubGridColIndex()).getSubGrid();
			if (gridITBGroupBy == 'view_scope')
				subgrid = sender.parentNode.parentNode.parentNode.grid;
		}
		else if (gridITBGroupBy == 'view_group') {
			subgrid = sender.parentNode.parentNode.parentNode.grid;
		}

		if (subgrid.getRowsNum() > subgrid.getRowIndex(id) + 1) {
			var nextId = subgrid.getRowId(subgrid.getRowIndex(id) + 1);
			subgrid.selectCell(nextId, sender.parentElement.parentElement.cellIndex);
			jQuery("input.contact-bid-amount", jQuery(subgrid.cells(nextId, 0).cell.parentElement)).focus();
			jQuery("input.contact-bid-amount", jQuery(subgrid.cells(nextId, 0).cell.parentElement)).select();
		}
		return false;
	}

	if (jQuery("img.contact-misc-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val(jQuery("input.contact-bid-amount", jQuery(sender).parent()).val());
		jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '70%');
		jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
	return true;
}

function ContactGroupBidAmountSave(sender, id, pc) {
	if (!jQuery("img.contact-misc-save", jQuery(sender).parent()).is(':visible'))
		return;

	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '');
	var bidAmount = jQuery("input.contact-bid-amount", jQuery(sender).parent()).val();
	if (!bidAmount || bidAmount.trim().length == 0)
		bidAmount = '0.00';

	bidAmount = bidAmount.replace(/,/g, "");

	PanteraScript.PanteraScriptService.SetProjectContactGroupBidAmount(pjqSessionId, parseInt(pc), id, parseFloat(bidAmount), null, onScriptError);
	if (GetBidAmountGridColIndex() > -1) {
		var subgrid = null;
		if (gridITBGroupBy == 'view_default' || gridITBGroupBy == 'view_scope') {
			if (gridITBGroupBy == 'view_default')
				subgrid = gridITB.cells(pc, GetGroupsSubGridColIndex()).getSubGrid();
			if (gridITBGroupBy == 'view_scope')
				subgrid = sender.parentNode.parentNode.parentNode.grid;

			var bidAmountTemp = 0.00;
			subgrid.forEachRow(function (id) {
				var bidAmount2 = jQuery("input.contact-bid-amount", jQuery(subgrid.cells(id, 0).cell.parentNode)).val();
				if (!bidAmount2 || bidAmount2.trim().length == 0)
					bidAmount2 = '0.00';
				bidAmount2 = bidAmount2.replace(/,/g, "");

				bidAmountTemp += parseFloat(bidAmount2);
			});
			if (gridITBGroupBy == 'view_default')
				gridITB.cells(pc, GetBidAmountGridColIndex()).setValue(bidAmountTemp.toFixed(2).toString());
			else if (gridITBGroupBy == 'view_scope') {
				sender.parentNode.parentNode.parentNode.grid.parentGrid.cells(pc, GetBidAmountGridColIndex()).setValue(bidAmountTemp.toFixed(2).toString());
			}
			subgrid.selectCell(id, sender.parentElement.parentElement.cellIndex);
		}
		else if (gridITBGroupBy == 'view_group') {
			subgrid = sender.parentNode.parentNode.parentNode.grid;
			if (subgrid.getUserData(null, 'IsGroupsGrid') == '1' && parseInt(subgrid.parentGrid.getUserData(pc, 'GroupId')) == id) {
				subgrid.parentGrid.cells(pc, GetBidAmountGridColIndex()).setValue(bidAmount.toString());
			}
			else {
				var subgrid2 = subgrid.cells(pc, GetGroupsSubGridColIndex()).getSubGrid();
				if (subgrid2) {
					subgrid2.forEachRow(function (groupRowId) {
						if (id == parseInt(groupRowId))
							subgrid2.cells(groupRowId, 2).setValue(bidAmount.toString());
					});
				}
			}
			subgrid.selectCell(id, sender.parentElement.parentElement.cellIndex);
		}
	}
}

function ContactGroupBidAmountCancel(sender) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '');
	jQuery("textarea.contact-notes", jQuery(sender).parent()).val(jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val());
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).val(jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val());
}

function GetCheckboxColIndex(grid) {
	for (var i = 0; i < grid.getColumnsNum(); i++) {
		if (grid.getColType(i) == 'ch')
			return i;
	}
	return -1;
}

function GetGroupsSubGridColIndex() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'sub_row_grid_groups')
				return i;
		}
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'sub_row_grid_groups')
				return i;
		}
	}

	return -1;
}

function GetGroupListColIndex() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'GroupList')
				return i;
		}
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'GroupList')
				return i;
		}
	}

	return -1;
}

function GetBidAmountGridColIndex() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'bidamount')
				return i;
		}
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'bidamount')
				return i;
		}
	}

	return -1;
}

function GetProjectStatusColIndex() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[2] == 'project_status_master')
				return i;
		}
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[2] == 'project_status_master' || parts[i].split('|')[2] == 'project_status_group')
				return i;
		}
	}

	return -1;
}

function GetProjectStatusColType() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[2] == 'project_status_master')
				return 'project_status_master';
		}
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[2] == 'project_status_master' || parts[i].split('|')[2] == 'project_status_group')
				return parts[i].split('|')[2];
		}
	}

	return '';
}

function GetContactInfoColIndex() {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'contactinfo')
				return i;
		}
	}
	else if (gridITBGroupBy.startsWith('view_group') || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		for (var i = 0; i < parts.length; i++) {
			if (parts[i].split('|')[0] == 'contactinfo')
				return i;
		}
	}
	else if (gridITBGroupBy == 'view_message' || gridITBGroupBy == 'view_status') {
		return 1;
	}

	return -1;
}

function GetColFieldnameByIndex(index) {
	if (gridITBGroupBy == 'view_default') {
		var parts = pjqITBLayoutDefault.split(',');
		return parts[index].split('|')[0];
	}
	else if (gridITBGroupBy == 'view_group' || gridITBGroupBy == 'view_scope') {
		var parts = pjqITBLayoutGroupCompany.split(',');
		return parts[index].split('|')[0];
	}

	return '';
}

function ManageContactGroups() {
	gridContactGroupsITB = new dhtmlXGridObject('grid-contact-groups');
	gridContactGroupsITB.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	gridContactGroupsITB.setSkin(pjqGridTheme);
	gridContactGroupsITB.enableAutoHeight(true, 500);
	gridContactGroupsITB.enableAutoWidth(true);

	gridContactGroupsITB.init();
	gridContactGroupsITB.load('/DesktopModules/PJQProjectWallAdmin/GetGroupListContactITB.aspx?sessionid=' + pjqSessionId + '&pc=' + subgridCheckedRows);

	jQuery("#dialog-contact-groups").dialog({
		resizable: false,
		height: 600,
		width: 550,
		title: 'Manage ' + settings.GroupLabel,
		modal: true,
		draggable: false,
		buttons: {
			Save: function () {
				var addGroupList = [];
				var deleteGroupList = [];
				gridContactGroupsITB.forEachRow(function (id) {
					if (gridContactGroupsITB.cells(id, 0).isChecked() && gridContactGroupsITB.getUserData(id, 'IsIncludedOriginal') == '0')
						addGroupList.push(id);
					else if (!gridContactGroupsITB.cells(id, 0).isChecked() && gridContactGroupsITB.getUserData(id, 'IsIncludedOriginal') == '1')
						deleteGroupList.push(id);
				});

				if (addGroupList.length > 0 || deleteGroupList.length > 0) {
					var subgrid = gridContactGroupsITB;
					PanteraScript.PanteraScriptService.ManageProjectContactGroups(pjqSessionId, parseInt(subgrid.getUserData(null, 'ContactId')), addGroupList.join(','), deleteGroupList.join(','), DeleteContactGroupC, onScriptError);

				}

				jQuery(this).dialog('close');
			}
		}
	});

}

function DeleteContactGroup() {
	var subgrid;
	if (gridITBGroupBy == 'view_group') {
		var contactSubGrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();
		subgrid = contactSubGrid.cells(contactSubGrid.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
	}
	else {
		subgrid = gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
	}
	PanteraScript.PanteraScriptService.ManageProjectContactGroups(pjqSessionId, parseInt(subgrid.getUserData(null, 'ContactId')), '', subgrid.getSelectedRowId(), DeleteContactGroupC, onScriptError);
}

function DeleteContactGroupC(response) {
	if (gridITBGroupBy == 'view_default') {
		var subgrid = gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
		if (gridITB.getUserData(gridITB.getSelectedRowId(), '__sub_row_last') == GetGroupsSubGridColIndex()) {
			if (gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).isOpen())
				gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).close();

			if (response != 'NO GROUPS') {
				var url = subgrid.xmlFileUrl + '&x' + (new Date).getTime().toString() + '=1';
				subgrid.clearAll();
				subgrid.loadXML(url, function () {
					subgrid.setSizes();
					subgrid.callEvent("onGridReconstructed", []);
					gridITB.setSizes();
				});
				gridITB.cells(gridITB.getSelectedRowId(), GetGroupsSubGridColIndex()).open();
			}
		}
		gridITB.cells(gridITB.getSelectedRowId(), GetGroupListColIndex()).setValue(response);
	}
	else if (gridITBGroupBy == 'view_group') {
		var subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();

		var subgrid2 = subgrid.cells(subgrid.getSelectedRowId(), GetGroupsSubGridColIndex()).getSubGrid();
		if (subgrid.getUserData(subgrid.getSelectedRowId(), '__sub_row_last') == GetGroupsSubGridColIndex()) {
			if (subgrid.cells(subgrid.getSelectedRowId(), GetGroupsSubGridColIndex()).isOpen())
				subgrid.cells(subgrid.getSelectedRowId(), GetGroupsSubGridColIndex()).close();

			if (response != 'NO GROUPS') {
				var url = subgrid2.xmlFileUrl + '&x' + (new Date).getTime().toString() + '=1';
				subgrid2.clearAll();
				subgrid2.loadXML(url, function () {
					subgrid2.setSizes();
					subgrid2.callEvent("onGridReconstructed", []);
					subgrid.setSizes();
				});
			}
			else {
				InitializeGridITB(gridITBGroupBy);
			}
			subgrid.cells(subgrid.getSelectedRowId(), GetGroupsSubGridColIndex()).open();
		}

		subgrid.cells(subgrid.getSelectedRowId(), GetGroupListColIndex()).setValue(response);
	}
}

function UploadBidDocuments() {
	PanteraScript.PanteraScriptService.GetNewGuid(UploadBidDocumentsC, onScriptError);
}

function UploadBidDocumentsC(response) {
	settings.BidDocUploadGuid = response;
	jQuery("#bid-doc-files table[role='presentation'] tbody tr").remove();
	if (!(pjqIsIE || (pjqBrowserVersion == 11 && navigator.userAgent.indexOf("rv:11") != -1)))
		jQuery('#bid-doc-files div.dropnotice').show();

	var pmUploadURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.BidDocUploadGuid + '&sid=' + pjqSessionId;
	jQuery('#fileuploadbd').attr('action', pmUploadURL);
	jQuery('#fileuploadbd').fileupload();
	jQuery('#fileuploadbd').fileupload('option', {
		autoUpload: true,
		url: pmUploadURL,
		dropZone: jQuery('#fileuploadbd')
	});

	if (!bidDocUploadInit) {
		jQuery('#fileuploadbd').bind('fileuploadstop', function (e, data) {
			jQuery('.dropnotice', jQuery('#bid-doc-files')).css('display', 'none');

			PanteraScript.PanteraScriptService.UploadProjectContactBidDocuments(pjqSessionId, parseInt(subgridCheckedRows), settings.BidDocUploadGuid, function (response) {
				PanteraScript.PanteraScriptService.SetProjectContactStatusAndNotes(pjqSessionId, parseInt(subgridCheckedRows), 'BID RECEIVED', '', false, onScriptError);
				var parts = response.split('|');
				settings.BidDocUploadGuid = parts[0];

				if (gridITBGroupBy == 'view_default') {
					gridITB.cells(gridITB.getSelectedRowId(), GetProjectStatusColIndex()).setValue(parts[1]);
				}
				else if (gridITBGroupBy == 'view_group') {
					var subgrid = gridITB.cells(gridITB.getSelectedRowId(), 0).getSubGrid();
					subgrid.cells(subgrid.getSelectedRowId(), GetProjectStatusColIndex()).setValue(parts[1]);
				}

				jQuery("#dialog-upload-bid-docs").dialog('close');

			}, onScriptError);

		});
		jQuery('#fileupload').bind('fileuploadstart', function (e, data) {
			jQuery('.dropnotice', jQuery('#bid-doc-files')).css('display', 'none');
		});
		jQuery('#fileupload').bind('fileuploadadd', function (e, data) {
			jQuery('.dropnotice', jQuery('#bid-doc-files')).css('display', 'none');
		});

		bidDocUploadInit = true;
	}


	var buttonList = {};

	var dlg = jQuery("#dialog-upload-bid-docs").dialog({
		resizable: false,
		height: 300,
		width: 500,
		title: 'Upload Bid Documents',
		modal: true,
		draggable: false,
		buttons: buttonList
	});

}


function ClearAllCheckboxes() {
	settings.SelectectContactsTemp.length = 0;
	settings.SelectectContactGroupsTemp.length = 0;
	if (gridITBGroupBy == 'view_default') {
		gridITB.forEachRow(function (id) {
			if (gridITB.getUserData(id, 'ProjectStatus') != settings.ProjectStatus[1]) {
				gridITB.cells(id, GetCheckboxColIndex(gridITB)).setChecked(false);
			}
		});

	}
	else {
		gridITB.forEachRow(function (id) {
			var subgrid = gridITB.cells(id, 0).getSubGrid();
			if (!subgrid)
				return;

			if (gridITBGroupBy == 'view_message' || gridITBGroupBy == 'view_response')
				SubGridCheckHelper(subgrid, GetCheckboxColIndex(subgrid), false);
			else
				SubGridCheckHelper(subgrid, GetCheckboxColIndex(subgrid), false);
		});
	}
}

function GetCheckedRowsITB() {
	if (gridITB == null)
		return;

	subgridCheckedRows = '';
	if (gridITBGroupBy == 'view_default') {
		subgridCheckedRows = gridITB.getCheckedRows(GetCheckboxColIndex(gridITB));
	}
	else {
		gridITB.forEachRow(function (id) {
			var subgrid = gridITB.cells(id, 0).getSubGrid();
			if (!subgrid)
				return;

			var subgridCheckedRowsTemp = '';
			subgridCheckedRowsTemp = subgrid.getCheckedRows(GetCheckboxColIndex(subgrid));

			if (subgridCheckedRowsTemp) {
				if (subgridCheckedRows)
					subgridCheckedRows += ',';
				subgridCheckedRows += subgridCheckedRowsTemp;
			}
		});
	}
}

function PlaceOrderC(response) {
	HideBusy();
	$('#dialog-order').dialog("close");
	showInfoDialogPWall('Order Placed', 'Order #' + response + ' has been placed successfully.', 'ui-icon-info');
	ClearAllCheckboxes();
	invalidProjectContacts = [];
	InitializeGridITB(gridITBGroupBy);
}

function PlaceOrderITB(pc) {

	let callback = _.bind(function() {
		invalidProjectContacts = [];

		// check that all contacts have the required fields first.

		PanteraScript.PanteraScriptService.CheckRecipientShippingInfo(pjqSessionId, pc ? pc : settings.SelectectContactsTemp.join(), PlaceOrderITBC, onScriptError);
	}, this);

	if (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === 'busy') {
		new PJQ.views.modals.YesNo({
			header: "Document(s) Processing",
			body: "Please Note: New documents are currently being processed for this project.  Are you sure you want to place an order?",
			onYes: _.bind(function () {
				callback();
			}, this)
		});
	}
	else
		callback();

}

function PlaceOrderITBC(response) {
	if (response == 'SUCCESS') {
		// launch Doc Selection dialog first, execution continues from there.
		SelectOrderDocs();
	}
	else {
		// the response contains the list of ProjectContactIds that are bad.  save to global.
		invalidProjectContacts = response.split(',');
		InitializeGridITB(gridITBGroupBy);
		var error = invalidProjectContacts.length.toString() + ' recipients have invalid shipping information.  These records are highlighted for editing.';
		if (invalidProjectContacts.length == 1)
			error = '1 recipient has invalid shipping information.  The record is highlighted for editing.';

		showInfoDialogPWall('Recipient Error', error, 'ui-icon-alert');
	}
}

function GetOrderOptions() {
	let initDlg = function () {
		// init order defaults.
		ClearValidationError('#lf-order-sets-label');
		ClearValidationError('#sf-order-sets-label');
		ClearValidationError('#order-conf-email');

		jQuery('#lf-order-sets').val(settings.OrderDefLFQty.toString()).spinner({
			min: 0,
			max: 50
		});
		jQuery('#lf-order-sets-half').val('0').spinner({
			min: 0,
			max: 50
		});
		jQuery('#lf-print-size').val(settings.OrderDefLFPrintSize);
		jQuery('#lf-paper-type').val(settings.OrderDefLFPaper);
		jQuery('#lf-binding').val(settings.OrderDefLFBinding);
		jQuery('#sf-order-sets').val(settings.OrderDefSFQty.toString()).spinner({
			min: 0,
			max: 50
		});
		jQuery('#sf-paper-type').val(settings.OrderDefSFPaper);
		jQuery('#sf-binding').val(settings.OrderDefSFBinding);
		jQuery('#cd-order-sets').val('0').spinner({
			min: 0,
			max: 50
		});
		if (settings.OrderDefLFPrintSize == 'HALF SIZE') {
			jQuery('#lf-order-sets').val('0');
			jQuery('#lf-order-sets-half').val(settings.OrderDefLFQty.toString());
		}
		else if (settings.OrderDefLFPrintSize == 'BURN DISC') {
			jQuery('#lf-order-sets').val('0');
			jQuery('#cd-order-sets').val(settings.OrderDefLFQty.toString());
		}

		jQuery('#order-deliverby').val(settings.OrderDefDeliverBy);
		jQuery('#order-notes').val('');
		jQuery('#order-conf-email').val(settings.Email);

		jQuery("#dialog-order").dialog({
			modal: true,
			resizable: false,
			title: 'Order Information',
			width: 500,
			buttons: {
				"Place Order": function () {
					ClearValidationError('#lf-order-sets-label');
					ClearValidationError('#sf-order-sets-label');
					ClearValidationError('#order-conf-email');

					// must have at least 1 set of either LF or SF
					var sfSets = parseInt(jQuery('#sf-order-sets').val());
					var lfSets = parseInt(jQuery('#lf-order-sets').val());
					var halfSets = parseInt(jQuery('#lf-order-sets-half').val());
					var cdSets = parseInt(jQuery('#cd-order-sets').val());

					var hasError = false;

					if (isNaN(halfSets))
						halfSets = 0;

					if (isNaN(cdSets))
						cdSets = 0;

					if (isNaN(sfSets)) {
						sfSets = 0;
						SetValidationError('#sf-order-sets-label', 'Please order a valid integer.');
						hasError = true;
					}

					if (isNaN(lfSets)) {
						lfSets = 0;
						SetValidationError('#lf-order-sets-label', 'Please order a valid integer.');
						hasError = true;
					}

					if (!hasError && sfSets + lfSets + halfSets + cdSets == 0) {
						SetValidationError('#lf-order-sets-label', 'Please order at least 1 set.');
						hasError = true;
					}

					// must have an order confirmation email address
					if (!ValidateEmail(jQuery('#order-conf-email').val())) {
						SetValidationError('#order-conf-email', 'Please enter a valid email address.');
						hasError = true;
					}

					if (hasError)
						return;

					$('div.ui-dialog-buttonpane button').button("option", 'disabled', true);
					ShowBusy('Saving...');

					// redirect to payment page if no account
					PanteraScript.PanteraScriptService.CreateOrderAdmin(pjqSessionId, settings.SelectectContactsTemp.join(), orderDocuments, lfSets, halfSets, jQuery('#lf-paper-type').val(), jQuery('#lf-binding').val(), sfSets, jQuery('#sf-paper-type').val(), jQuery('#sf-binding').val(), cdSets, jQuery('#order-deliverby').val(), jQuery('#order-conf-email').val(), jQuery('#order-notes').val(), PlaceOrderC, onScriptError);
				}
			}
		});
	};
	if (_.size(jQuery("#dialog-order")) === 0) {
		PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'ProjectWallAdmin-Dialog-Place-Order'), $('#pjq-main'), {}, function () {
			initDlg();
		});
	}
	else {
		initDlg();
	}
}

function PWCheckAllC(response) {
	HideBusy();
	var list = response.d.ProjectContacts;
	if (list.length > 0) {
		var j = 0,
			index = -1;
		for (j = 0; j < list.length; j++) {
			var item = parseInt(list[j]);
			index = -1;

			for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
				if (settings.SelectectContactsTemp[i] == parseInt(list[j]))
					index = i;
			}
			if (index == -1)
				settings.SelectectContactsTemp.push(parseInt(list[j]));
		}
	}
}

function PWUncheckAllC(response) {
	HideBusy();
	var list = response.d.ProjectContacts;
	if (list.length > 0) {
		var j = 0,
			index = -1;
		for (j = 0; j < list.length; j++) {
			var item = parseInt(list[j]);
			index = -1;

			for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
				if (settings.SelectectContactsTemp[i] == parseInt(list[j]))
					index = i;
			}
			if (index != -1)
				settings.SelectectContactsTemp.splice(index, 1);
		}
	}
}

/************ SCOPES ****************/
function eXcell_scope_main(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {
		var isDisabled = PJQ.app.session.user == null || PJQ.app.session.user.get('userTypeId') === 3552;
		var parts = val.split("||");
		var notes = '';
		if (parts[1])
			notes = parts[1];
		var template = "<div style='width: 98%; height: 100%; padding: 2px;'><span class='pjq-field-label'>" + parts[0] + ":</span><br /><textarea " + (isDisabled ? "disabled" : "") + " class='scope-text' onkeydown='ScopeTextChanged(this)' oncontextmenu='ScopeContext(event, this);'>" + notes + "</textarea>";
		template += "&nbsp;&nbsp;<img class='scope-text-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ScopeTextSave(this, \"" + this.cell.parentNode.idd + "\");' /> <img class='scope-text-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ScopeTextCancel(this);' /><input type='hidden' class='scope-text-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_scope_main.prototype = new eXcell; // nest all other methods from base class
eXcell_scope_main.prototype.getTitle = function () {

	var tip = jQuery("span.pjq-field-label", jQuery(this.cell)).text() + ' ' + jQuery("textarea.scope-text", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function ScopeContext(ev, sender) {
	//var cell = jQuery(sender).parent();
	//cell.trigger({type:'mousedown',button:2}).trigger({type:'mouseup'});
	ev.stopPropagation();
	//cmITB_P.showContextMenu(ev.pageX, ev.pageY);
}

function ScopeTextChanged(sender) {
	if (jQuery("img.scope-text-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery("input.scope-text-original", jQuery(sender).parent()).val(jQuery("textarea.scope-text", jQuery(sender).parent()).val());
		jQuery("img.scope-text-save,img.scope-text-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
}

function ScopeTextSave(sender, id) {
	PanteraScript.PanteraScriptService.SetProjectScopeText(pjqSessionId, id, unescape(jQuery("textarea.scope-text", jQuery(sender).parent()).val()), null, onScriptError);
	jQuery("img.scope-text-save, img.scope-text-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
}

function ScopeTextCancel(sender, id) {
	jQuery("textarea.scope-text", jQuery(sender).parent()).val(jQuery("input.scope-text-original", jQuery(sender).parent()).val());
	jQuery("img.scope-text-save, img.scope-text-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
}

function eXcell_scope_count(cell) { // message status
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {
		var isDisabled = PJQ.app.session.user == null || PJQ.app.session.user.get('userTypeId') === 3552;
		var template = "<select " + (isDisabled ? "disabled" : "") + " class='scope-count' onchange='ScopeCountChange(this, \"" + this.cell.parentNode.idd + "\")'>";

		var i = 0;
		var isSelected = '';
		for (i = 0; i <= 10; i++) {
			isSelected = '';
			if (val == i.toString())
				isSelected = "selected='selected'";
			template += "<option value='" + i.toString() + "' " + isSelected + ">" + i.toString() + "</option>";
		}
		isSelected = '';
		if (val == '-1')
			isSelected = "selected='selected'";
		template += "<option value='-1' " + isSelected + ">Designated</option>";

		template += "</select>";

		this.setCValue(template);
	}
}

eXcell_scope_count.prototype = new eXcell; // nest all other methods from base class
eXcell_scope_count.prototype.getTitle = function () {

	var tip = jQuery("select.scope-count", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return this.cell.innerHTML;
}

function ScopeCountChange(sender, id) {
	PanteraScript.PanteraScriptService.SetProjectScopeCount(pjqSessionId, id, decodeURIComponent(jQuery(sender).val().replace(/% /g, '%25 ').replace(/%\./g, '%25.').replace(/%$/, '%25')), null, onScriptError);
}

dhtmlXGridObject.prototype._in_header_master_checkbox_itb = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			if (b.isCheckbox() && !b.isDisabled())
				b.setValue(g), b.cell.wasChanged = !0;
			this.callEvent("onEditCell", [1, a, c, g]);
			this.callEvent("onCheckbox", [a, c, g])
		});

		if (gridITBGroupBy === 'view_default') {
			var searchFor = tbITBSearch.getValue('search_for');
			var ssl = GetSearchStatusList();

			var searchGroupList = '';
			jQuery('#filter-response-group-list input:checked').each(function () {
				searchGroupList = searchGroupList + jQuery(this).val() + ',';
			});
			if (searchGroupList.length > 0)
				searchGroupList = searchGroupList.substring(0, searchGroupList.length - 1);

			if (null != filterGroupTree)
				searchGroupList = filterGroupTree.getAllChecked();


			if (g) {
				ShowBusy('Checking All...');
			}
			else {
				ShowBusy('Unchecking All...');
			}

			var getProjectContactsURL = "/DesktopModules/PJQProjectWallAdmin/GetProjectContacts.aspx?sessionId=" + pjqSessionId + "&x=" + (new Date).getTime();
			if (enableDeclined)
				getProjectContactsURL += "&ed=1";

			$.getJSON(getProjectContactsURL, function (data) {

				if (g) {
					PWCheckAllC(data);
				}
				else {
					PWUncheckAllC(data);
				}

				gridITB.forEachRow(function (rId) {
					var subgrid = gridITB.cells(rId, 0).getSubGrid();
					if (subgrid) {
						SubGridCheckHelper(subgrid, GetCheckboxColIndex(subgrid), true);
					}
				});
				HideBusy();
			});


			gridITB.forEachRow(function (rId) {
				var isDeclined = (gridITB.getUserData(rId, 'ProjectStatus') == settings.ProjectStatus[1]);

				if (isDeclined && !enableDeclined) {
					gridITB.cells(rId, GetCheckboxColIndex(gridITB)).setChecked(false);
					gridITB.cells(rId, GetCheckboxColIndex(gridITB)).setDisabled(true);
				}
				var i,
					index = -1,
					state = gridITB.cells(rId, GetCheckboxColIndex(gridITB)).isChecked();
				for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
					if (settings.SelectectContactsTemp[i] == parseInt(rId))
						index = i;
				}

				if (state && index == -1 && (!isDeclined || enableDeclined))
					settings.SelectectContactsTemp.push(parseInt(rId));
				else if (index != -1 && (!state || (isDeclined && !enableDeclined)))
					settings.SelectectContactsTemp.splice(index, 1);
			});
		}
		else {
			gridITB.forEachRow(function (rId) {
				var subgrid = gridITB.cells(rId, 0).getSubGrid();
				if (!subgrid)
					return;

				subgrid.forEachRow(function (rId2) {
					var pc = '',
						state;

					if (gridITBGroupBy === 'view_message') {
						pc = subgrid.getUserData(rId2, "ProjectContactId");
						state = subgrid.cells(rId2, GetCheckboxColIndex(subgrid)).isChecked();

					}
					else {
						pc = rId2;
						state = subgrid.cells(rId2, GetCheckboxColIndex(subgrid)).isChecked();
						if (gridITBGroupBy.indexOf('view_group') > -1) {
							var groupId = subgrid.getUserData(rId2, 'GroupId');
							selectedContactGroups.push(rId2 + '|' + groupId);
						}
					}
					var i,
						index = -1;
					for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
						if (settings.SelectectContactsTemp[i] == parseInt(pc))
							index = i;
					}

					if (state && index == -1)
						settings.SelectectContactsTemp.push(parseInt(pc));
					else if (!state && index != -1)
						settings.SelectectContactsTemp.splice(index, 1);

				});
			});
		}
		ParticipantToolbarRefresh();
		(a || event).cancelBubble = !0;
	}
};

function grid_sort_scope(a, b, order) {
	var optionA = a.substring(0, a.indexOf(':</span>'));
	optionA = optionA.substring(optionA.lastIndexOf(">"));
	var optionB = b.substring(0, b.indexOf(':</span>'));
	optionB = optionB.substring(optionB.lastIndexOf(">"));

	if (!optionA)
		optionA = a;

	if (!optionB)
		optionB = b;

	optionA = optionA.toLowerCase();
	optionB = optionB.toLowerCase();

	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;
}

function grid_sort_distance(a, b, order) {
	var optionA = a ? (a == "N/A" ? -1 : a) : -1;
	var optionB = b ? (b == "N/A" ? -1 : b) : -1;

	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return parseFloat(optionA) > parseFloat(optionB) ? 1 : -1;
	else
		return parseFloat(optionA) < parseFloat(optionB) ? 1 : -1;

}

function grid_sort_company(a, b, order) {
	var optionA = a.substring(a.indexOf('<td class="company-name" colspan="2">'));
	var optionB = b.substring(b.indexOf('<td class="company-name" colspan="2">'));

	optionA = optionA.substring(0, optionA.indexOf('</td>'));
	optionB = optionB.substring(0, optionB.indexOf('</td>'));

	if (!optionA)
		optionA = a;

	if (!optionB)
		optionB = b;

	optionA = optionA.toLowerCase().trim();
	optionB = optionB.toLowerCase().trim();

	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;

}

function grid_sort_selectoption(a, b, order) {
	var optionA = a.substring(0, a.indexOf('selected'));
	optionA = optionA.substring(0, optionA.lastIndexOf('"'));
	optionA = optionA.substring(optionA.lastIndexOf('"') + 1);
	var optionB = b.substring(0, b.indexOf('selected'));
	optionB = optionB.substring(0, optionB.lastIndexOf('"'));
	optionB = optionB.substring(optionB.lastIndexOf('"') + 1);

	if (!optionA)
		optionA = a;

	if (!optionB)
		optionB = b;

	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;
}

function SetResponseITB() {
	GetCheckedRowsITB();
	var status = jQuery('#project-status-response').val();
	var notes = jQuery('#project-status-notes').val();

	var now = new Date();
	if (settings.IsNotesAutoTimestamp && notes.length > 0) {
		notes = notes + " \nEdited: " + now.toLocaleString().replace(/\u200E/g, '') + " by " + settings.UserDisplayName;
	}

	if (gridITBGroupBy != 'view_message')
		PanteraScript.PanteraScriptService.SetProjectContactStatusAndNotes(pjqSessionId, settings.SelectectContactsTemp.join(','), status, notes, RefreshGridITBC, onScriptError);
}

function ResendContactsITB() {
	//GetCheckedRowsITB();
	subgridCheckedRows = '';
	var list = [];
	gridITB.forEachRow(function (id) {
		var subgrid = gridITB.cells(id, 0).getSubGrid();
		if (!subgrid)
			return;

		subgrid.forEachRow(function (id2) {
			if (subgrid.cells(id2, GetCheckboxColIndex(subgrid)).isChecked())
				list.push(id2);
		});

	});
	subgridCheckedRows = list.join(',');
	PanteraScript.PanteraScriptService.ResendProjectMessageContactBroadcasts(pjqSessionId, subgridCheckedRows, ResendContactITBC, onScriptError);
}

function ResendContactITB() {
	PanteraScript.PanteraScriptService.ResendProjectMessageContactBroadcasts(pjqSessionId, subgridCheckedRows, ResendContactITBC, onScriptError);
}

function ResendContactITBC() {
	showInfoDialogPWall('Message Resent', 'The selected message has been successfully resent.');
}

function DeleteMessageITB() {
	var rowId = gridITB.getSelectedRowId();
	if (gridITBGroupBy == 'view_message')
		PanteraScript.PanteraScriptService.DeleteProjectMessage(pjqSessionId, rowId, RefreshGridITBC, onScriptError);
}

function ScopeAddParticipantsC(response) {
	HideBusy();
	if (response.startsWith('INFO:'))
		showInfoDialogPWall('Add Participants from Scopes', response.substring(5), 'ui-icon-alert');
	else {
		var list = response.split(',');
		var i;
		for (i = 0; i < list.length; i++) {
			if (list[i].length > 0)
				settings.SelectectContactsTemp.push(parseInt(list[i]));
		}
		InitializeGridITB(gridITBGroupBy);
		subgridCheckedRows = response;
		tbITB.enableItem("set_response_multiple");
		tbITB.enableItem("delete_multiple");
		tbITB.enableItem("order_prints_multiple");
		showInfoDialogPWall('Add Participants from Scopes', list.length.toString() + ' Participants added for Scopes.', 'ui-icon-info');

	}
}

function QuickAddC(response) {
	// add the newly added Project Contacts to the Selected Contacts array
	var idList = response.split(',');
	for (var j = 0; j < idList.length; j++) {
		var i, index = -1;
		for (i = 0; i < settings.SelectectContactsTemp.length; i++) {
			if (settings.SelectectContactsTemp[i] == parseInt(idList[j]))
				index = i;
		}

		if (index == -1)
			settings.SelectectContactsTemp.push(parseInt(idList[j]));
	}
	InitializeGridITB(gridITBGroupBy);
}

var prequalRequestContactId = 0;

function RequestProjectContactPrequalificationHelper(thisRequestContactId) {
	prequalRequestContactId = thisRequestContactId;
	showInfoDialogPWall('Send Prequal Request', 'Are you sure you want to send this contact a prequalification request?', 'ui-icon-alert', 'request-prequal-project');
}

function RequestProjectContactPrequalification() {
	PanteraScript.PanteraScriptService.RequestProjectContactPrequalification(pjqSessionId, prequalRequestContactId, RequestContactPrequalificationC, onScriptError);
}

function RequestContactPrequalificationHelper(thisRequestContactId) {
	prequalRequestContactId = thisRequestContactId;
	showInfoDialogPWall('Send Prequal Request', 'Are you sure you want to send this contact a prequalification request?', 'ui-icon-alert', 'request-prequal');
}

function RequestContactPrequalification() {
	PanteraScript.PanteraScriptService.RequestContactPrequalification(pjqSessionId, prequalRequestContactId, RequestContactPrequalificationC, onScriptError);
}

function RequestContactPrequalificationC(response) {
	var pResult = jQuery.parseJSON(response);
	if (pResult.Result)
		showInfoDialogPWall('Prequalification Request Sent', 'A prequalification request has been sent to the selected contact.  ', 'ui-icon-info');
	else {
		var failureReason = "";
		if (pResult.ResultNote == "noEmail")
			failureReason = "The selected contact does not have an email address.  Please add one and try again.";
		else if (pResult.ResultNote == "badEmail")
			failureReason = "The selected contact's email address is opted out'.  Please update it and try again, or contact customer service if you believe this to be incorrect.";

		showInfoDialogPWall('Prequalification Request Not Sent', failureReason, 'ui-icon-info');
	}
}

var reportProjectContactId = 0;
var isReportPrivateContact = false;

function InitReportContactDialog(rpcId) {
	reportProjectContactId = rpcId;
	var reportContactReasons = ["Out of business", "Wrong phone number", "Bad Email"];
	jQuery('#reportContactDialog').dialog({
		title: "Report Directory Contact",
		modal: true,
		resizable: false,
		width: 450,
		dialogClass: 'reportContactDialog',
		buttons: {
			"Report": function () {
				jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
				var reportReason = jQuery('#reportContactReason').find('option:selected').text();
				if (parseInt(jQuery('#reportContactReason').val()) == -1 || (settings.IsEnableReportPrivateContact && jQuery('#reportContactReasonOther').val().length > 0)) {
					reportReason += ': ' + jQuery('#reportContactReasonOther').val();
				}
				PanteraScript.PanteraScriptService.ReportContactByProjectContact(pjqSessionId, reportProjectContactId, reportReason, ReportContactC, onScriptError);
			},
			"Cancel": function () {
				jQuery(this).dialog('close');
			}
		},
		open: function () {
			jQuery('#reportContactReasonOther').val('');
			jQuery('#reportContactReason').empty();
			jQuery('#reportContactReason').append('<option value="">Select...</option>')
			for (var i = 0; i < reportContactReasons.length; i++) {
				jQuery('#reportContactReason').append('<option value="' + i + '">' + reportContactReasons[i] + '</option>');
			}
			jQuery('#reportContactReason').append('<option value="-1">Other</option>');
			jQuery('#reportContactReason').off();
			jQuery('#reportContactReason').on('change', function () {
				if (jQuery(this).val().length == 0) {
					jQuery('#reportContactReasonOther').hide();
					jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
					return;
				}
				else if (parseInt(jQuery(this).val()) == -1 || isReportPrivateContact) {
					jQuery('#reportContactReasonOther').show();
					jQuery('#reportContactReasonOther').off();
					jQuery('#reportContactReasonOther').on('keyup', function () {
						if (jQuery('#reportContactReasonOther').val().length > 0)
							jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
						else
							jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('disable');
					});
					jQuery('#reportContactReasonOther').trigger('keyup');
				}
				else {
					jQuery('#reportContactReasonOther').hide();
					jQuery('.reportContactDialog').find('.ui-dialog-buttonset').children('button:first-child').button('enable');
				}
			});
			jQuery('#reportContactReason').trigger('change');
		}
	});
}

function ReportContactC(response) {
	jQuery('#reportContactDialog').dialog('close');
	if (isReportPrivateContact) {
		showInfoDialogPWall('Contact Reported', 'The selected contact has been reported and will be reviewed by an administrator.', 'ui-icon-info');
	}
	else {
		//2017-10-25 Blue: Removed the success dialog , as the grid is refreshing behind the dialog and causing issues with large # of rows-per-page.
		//showInfoDialogPWall('Contact Reported', 'The selected contact has been reported to customer service and removed from your address book.', 'ui-icon-info');

		gridITB.clearAll();
		InitializeGridITB(gridITBGroupBy);
	}
}

function InitializeSetResponseMultiple() {
	jQuery('#project-status-response').val('');
	jQuery('#project-status-notes').val('');
	jQuery("#project-status-window").dialog({
		modal: true,
		title: 'Set Response',
		width: 500,
		buttons: {
			"Set Response": function () {
				SetResponseITB();
				$(this).dialog("close");
			}
		}
	});

}

function ColorCodeRows() {
	var dataRow = 0;
	if (gridITBGroupBy == 'view_message')
		dataRow = 1;
	else if (gridITBGroupBy == 'view_group')
		dataRow = 4;
	else if (gridITBGroupBy == 'view_response')
		dataRow = 2;
	gridITB.forEachRow(function (id) {
		if (gridITBGroupBy == 'view_default') {
			var rowColor = gridITB.cells(id, GetContactInfoColIndex()).getValue().toLowerCase();
			jQuery('body').append('<div style="display:none;" id="parseColorTempDiv"></div>');
			jQuery('#parseColorTempDiv').html(rowColor);
			rowColor = jQuery('#parseColorTempDiv').find('td:contains("color:")').siblings('td').text().toString();
			jQuery('#parseColorTempDiv').remove();
			gridITB.setRowColor(id, GetRichardRichardRowColor(rowColor));
		}
		var subgrid = gridITB.cells(id, 0).getSubGrid();
		if (subgrid != null) {
			subgrid.forEachRow(function (id2) {
				var rowColor = subgrid.cells(id2, dataRow).getValue().toLowerCase();
				jQuery('body').append('<div style="display:none;" id="parseColorTempDiv"></div>');
				jQuery('#parseColorTempDiv').html(rowColor);
				rowColor = jQuery('#parseColorTempDiv').find('td:contains("color:")').siblings('td').text().toString();
				jQuery('#parseColorTempDiv').remove();

				subgrid.setRowColor(id2, GetRichardRichardRowColor(rowColor));
			});
		}
	});
}

function FilterSelectedOnly() {
	tbITBSearch.setItemText('info', 'NOTE: Filtered to Selected Participants Only');
	isCreatingMessage = true;
	var iapo = settings.IsPMAttachPrivateOpen = !jQuery('#project-message-private-folders').hasClass('pjq-hidden');
	var pfis = settings.PMPrivateFolderIds = GetCheckedPrivateFolders();
	dlgPM.dialog("close");
	settings.IsPMAttachPrivateOpen = iapo;
	settings.PMPrivateFolderIds = pfis;


	jQuery('#grid-toolbar-itb').hide();
	FilterClearAll();
	dlgPM.dialog("close");
	filterSelectedOnly = true;
	var quickAddList = jQuery('#project-message-quickadd').val();
	var subject = jQuery('#project-message-subject').val();
	var templateKey = jQuery('#project-message-type').val();
	var responseType = jQuery('#project-message-response-type').val();
	var responseDueDate = jQuery('#project-message-response-due').val();
	var responseDueASAP = false;
	if (jQuery('#project-message-response-due-asap').prop('checked'))
		responseDueASAP = true;
	var isAllowPublic = jQuery('#project-message-allow-comments').prop('checked');
	var sendOptions = "EMAIL";
	if (jQuery('#project-message-send-fax').prop('checked'))
		sendOptions += ',FAX_AND_EMAIL';
	if (jQuery('#project-message-send-email-or-fax').prop('checked'))
		sendOptions += ',EMAIL_OR_FAX';
	if (jQuery('#project-message-send-fax-if-email-fails').prop('checked'))
		sendOptions += ',EMAIL_FAX_FAILS';

	PanteraScript.PanteraScriptService.CreateProjectContactTempContext(PJQ.app.session.id, settings.SelectectContactsTemp.join(), quickAddList, subject, cleanWordPaste(msgEditor.getContent()), templateKey, responseType, responseDueDate, responseDueASAP, sendOptions, isAllowPublic, !jQuery('#project-message-private-folders').hasClass('pjq-hidden'), GetCheckedPrivateFolders(), FilterSelectedOnlyC, onScriptError);

	if (jQuery('#tabsMain').tabs('option', 'active') != 2)
		jQuery('#tabsMain').tabs('option', 'active', 2);

	tbITBSearch.hideItem('export');
	tbITBSearch.hideItem('export_sep');

	tbITBSearch.hideItem('export_messages_sep');
	tbITBSearch.hideItem('export_messages');

	let newItbBtn = jQuery('#create-new-itb');
	if (newItbBtn.hasClass('ui-button')) {
		newItbBtn.button('option', 'label', resumeLabel);
	}
	else {
		newItbBtn.find('.btn-text').text(resumeLabel);
	}
}

function FilterSelectedOnlyC() {
	InitializeGridITB('view_default');
}


/*********** BID AMOUNT *************/
function eXcell_bidamount_itb(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<div style='width: 90%; '>";
		template += "<input type='text' class='contact-bid-amount' value='" + val + "'  onblur='ContactBidAmountSave(this, " + this.cell.parentNode.idd + ");'  onkeypress='ContactBidAmountChanged(this);' onchange='jQuery(this).val( parseFloat(jQuery(this).val()).toFixed(2).toString());' /> <img class='contact-misc-save pjq-hidden' src='/i/save2.gif' title='Save' onclick='ContactBidAmountSave(this, " + this.cell.parentNode.idd + ");' /> <img class='contact-misc-cancel pjq-hidden' src='/i/cancelb.gif' title='Cancel' onclick='ContactBidAmountCancel(this);' /><input type='hidden' class='contact-misc-bidamount-original' /></div>";

		this.setCValue(template);
	}
}

eXcell_bidamount_itb.prototype = new eXcell; // nest all other methods from base class
eXcell_bidamount_itb.prototype.getTitle = function () {

	var tip = jQuery("input.contact-bid-amount", jQuery(this.cell)).val();

	if (tip)
		return tip;

	return '';
}

function ContactBidAmountChanged(sender, id, pc) {
	if (typeof (event) != 'undefined' && (event.keyCode == 13 || event.keyCode == 9)) {
		event.preventDefault();
		jQuery("input.contact-bid-amount", jQuery(sender).parent()).blur();
		jQuery("img.contact-misc-save", jQuery(sender).parent()).click();
		return false;
	}

	if (jQuery("img.contact-misc-save", jQuery(sender).parent()).hasClass("pjq-hidden")) {
		jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val(jQuery("input.contact-bid-amount", jQuery(sender).parent()).val());
		jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '70%');
		jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).removeClass("pjq-hidden");
	}
	return true;
}

function ContactBidAmountSave(sender, id) {
	if (!jQuery("img.contact-misc-save", jQuery(sender).parent()).is(':visible'))
		return;

	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '');
	var bidAmount = jQuery("input.contact-bid-amount", jQuery(sender).parent()).val();
	if (!bidAmount)
		bidAmount = '0.00';
	bidAmount = bidAmount.replace(/,/g, "");
	PanteraScript.PanteraScriptService.SetProjectContactBidAmount(pjqSessionId, id, parseFloat(bidAmount), null, onScriptError);
}

function ContactBidAmountCancel(sender) {
	jQuery("img.contact-misc-save,img.contact-misc-cancel", jQuery(sender).parent()).addClass("pjq-hidden");
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).css('width', '');
	jQuery("textarea.contact-notes", jQuery(sender).parent()).val(jQuery("input.contact-misc-notes-original", jQuery(sender).parent()).val());
	jQuery("input.contact-bid-amount", jQuery(sender).parent()).val(jQuery("input.contact-misc-bidamount-original", jQuery(sender).parent()).val());
}

function FilterUnsent() {
	filterUnsent = false;

	// if any search or filter options are set, show a warning
	var searchFor = tbITBSearch.getValue('search_for');
	var statusList = GetSearchStatusList();
	searchGroupList = GetGroupFilterList();

	if (searchFor || statusList || searchGroupList) {
		showInfoDialogPWall('Filtered Participants', 'There are already filters in effect that may hide some participants.  Click OK if you would like to clear existing filters.', 'ui-icon-alert', 'filter-unsent');
		return;
	}

	// otherwise just set the 'unsent' filter and refresh view.
	filterUnsent = true;
	InitializeGridITB(gridITBGroupBy);
}

function GetGroupFilterList() {
	searchGroupList = '';
	jQuery('#filter-response-group-list input:checked').each(function () {
		searchGroupList = searchGroupList + jQuery(this).val() + ',';
	});
	if (searchGroupList.length > 0)
		searchGroupList = searchGroupList.substring(0, searchGroupList.length - 1);

	if (null != filterGroupTree) {
		searchGroupList = filterGroupTree.getAllChecked().replace('-9999', '0');
	}

	return searchGroupList;
}

function GetSearchStatusList() {
	var ssl = '';
	jQuery('td.filter-response-status-list input:checked').each(function () {
		ssl = ssl + decodeURIComponent(jQuery(this).val()) + ',';
	});

	if (filterUnsent && ssl.indexOf('UNSENT') == -1)
		ssl += 'UNSENT,';

	if (jQuery('#filter-visited-yes').prop('checked'))
		ssl += 'VISITED,';

	if (jQuery('#filter-downloaded-yes').prop('checked'))
		ssl += 'DOWNLOADS,';

	if (jQuery('#filter-print-order-yes').prop('checked'))
		ssl += 'ORDERS ONLY,';

	if (jQuery('#filter-broadcast-status-email-sent').prop('checked'))
		ssl += 'EMAIL SENT,';

	if (jQuery('#filter-broadcast-status-email-failed').prop('checked'))
		ssl += 'EMAIL FAILED,';

	if (jQuery('#filter-broadcast-status-fax-sent').prop('checked'))
		ssl += 'FAX SENT,';

	if (jQuery('#filter-broadcast-status-fax-failed').prop('checked'))
		ssl += 'FAX FAILED,';

	if (jQuery('#filter-broadcast-status-error').prop('checked'))
		ssl += 'ERROR,';

	if (jQuery('#filter-union').prop('checked'))
		ssl += 'IS_UNION,';

	if (jQuery('#filter-nonunion').prop('checked'))
		ssl += 'IS_NONUNION,';

	if (jQuery('#filter-prevwage').prop('checked'))
		ssl += 'IS_PREVWAGE,';

	if (jQuery('#filter-directory-private').prop('checked'))
		ssl += 'IS_PRIVATE,';

	if (jQuery('#filter-directory-public').prop('checked'))
		ssl += 'IS_PUBLIC,';

	if (ssl.length > 0)
		ssl = ssl.substring(0, ssl.length - 1);

	return ssl;
}

function PMUploadRefresh(context) {
	settings.FileUploadGuid = context;
	fileUploadCounter = 0;
	jQuery("#project-message-files table[role='presentation'] tbody tr").remove();

	var pmUploadURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.FileUploadGuid + '&sid=' + pjqSessionId;
	jQuery('#fileupload').attr('action', pmUploadURL);
	try {
		jQuery('#fileupload').fileupload('destroy');
		jQuery('#fileupload').data('blueimp-fileupload').uploadFileCount = 0;
		jQuery('#fileupload').data('blueimp-fileupload').uploadedFiles = [];
	} catch (err) {
	}

	fuPM = jQuery('#fileupload').fileupload();

	jQuery('#fileupload').fileupload('option', {
		autoUpload: true,
		url: pmUploadURL,
		dropZone: jQuery('#fileupload')
	});
	jQuery('.dropnotice', jQuery('#project-message-files')).css('display', '');

	if (settings.IsSendAttachmentWithEmail) {
		jQuery('#fileupload').fileupload('option', 'maxTotalFileSize', 15728640);
	}

	jQuery('#fileupload').bind('fileuploadstop', function (e, data) {
		jQuery('.dropnotice', jQuery('#private-message-files')).css('display', 'none');
		jQuery('#project-message-send').button('enable');
	});
	jQuery('#fileupload').bind('fileuploadstart', function (e, data) {
		jQuery('.dropnotice', jQuery('#private-message-files')).css('display', 'none');
		jQuery('#project-message-send').button('disable');
	});
	jQuery('#fileupload').bind('fileuploadadd', function (e, data) {
		jQuery('.dropnotice', jQuery('#private-message-files')).css('display', 'none');
	});

	// Load existing files:

	$.ajax({
		// Uncomment the following to send cross-domain cookies:
		//xhrFields: {withCredentials: true},
		url: pmUploadURL,
		dataType: 'json',
		context: $('#fileupload')[0]
	}).done(function (result) {
		jQuery('#fileupload').data('blueimp-fileupload').uploadFileCount = 0;
		jQuery('#fileupload').data('blueimp-fileupload').uploadedFiles = [];
		$('#fileupload').fileupload('option', 'done')
			.call(this, null, {
				result: result
			});
		if (result && result.length > 0)
			jQuery('.dropnotice', jQuery('#project-message-files')).css('display', 'none');
	});


}

function PMUploadReInitialize(response) {
	PMUploadRefresh(response);
}

function ProjectHomeDisable() {
	jQuery('#project-home input, #project-home select, #project-home textarea').prop('disabled', true);
	jQuery('#project-home input.pjq-date-field-width, #project-home input.pjq-time-field-width, #project-home input.pjq-numeric-field-width').each(function () {
		if (jQuery(this).prop('tagName') == 'INPUT' && jQuery(this).hasClass('pjq-date-field-width')) {
			jQuery(this).datepicker('disable');
		}
		else if (jQuery(this).prop('tagName') == 'INPUT' && jQuery(this).hasClass('pjq-time-field-width')) {
			jQuery(this).timepicker('disable');
		}
		else if (jQuery(this).prop('tagName') == 'INPUT' && jQuery(this).hasClass('pjq-numeric-field-width')) {
			jQuery(this).spinner('disable');
		}
	});

	for (var i = 0; i < projectContactFields.length; i++) {
		var tb = projectContactFields[i][1];
		tb.disableItem("add");
		tb.disableItem("edit");
		tb.disableItem("delete");
	}
}
